/* jshint -W024 */
const UserRoutes = [
  {
    path: '/change-details',
    name: 'change-details',
    meta: {
      roles: [],
      auth: true,
      ignore: true
    },
    component: () => import('@/ui/views/internal/profile/ChangeDetails.vue')
  }
];

export default UserRoutes;
